﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerAddress } from '../util/server-address';
import { User } from '../model/user';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {map} from 'rxjs/operators';



@Injectable()
export class AuthenticationService {

    _serverAddress = ServerAddress.getInstance();

    private _authenticateUrl = '';

    public user: User;
    constructor(private _http: HttpClient) {
        // set token if saved in local storage
        this.user = JSON.parse(localStorage.getItem('user'));

        if (window.location.port === '4200') {
            this._serverAddress.setValue('http://localhost:8080/');
        }

        this._authenticateUrl = this._serverAddress.getValue() + 'login';



    }

    login(username: any, password: any): Observable<boolean> {

        let success = false;
        return this._http.post(this._authenticateUrl, JSON.stringify({ username: username, password: password }), {observe: 'response'})
            .pipe(map(
                (result: HttpResponse<any>) => {
                    if (result) {
                        localStorage.setItem('Authorization', result.headers.get('Authorization'));
                        let role:number;
                        switch (result.headers.get('Authority')) {
                          case 'ROLE_ADMIN' : role = 1;break;
                          case 'ROLE_USER' : role = 2;break;
                        }
                        console.log('List of all keys');
                        for(const key of result.headers.keys()) {
                            console.log(key);
                        }
                        console.log(result.headers.get('Authority'));
                        console.log('Authentication success');
                        console.log(role +' '+ result.headers.get('User'));
                        this.user = new User(role, result.headers.get('User'));
                        localStorage.setItem('user', JSON.stringify(this.user));
                        success =  true;
                        return success;
                    } else {
                        success = false;
                    }
                        return success;
                }


            ));
    }



    logout(): void {
        // clear token remove user from local storage to log user out
        this.user = null;
        localStorage.removeItem('user');
        localStorage.removeItem('project_id');
    }


    isLogin(loginResult): boolean {
        console.log(loginResult);
        if (!loginResult.error) {
            this.user = new User(loginResult.user.type, loginResult.user.token);
                localStorage.setItem('user', JSON.stringify(this.user));
            // return true to indicate successful login
            return true;
        } else {

            return false;
        }
    }

}
